<template>
  <nav id="tools-nav" class="navbar navbar-expand-xl navbar-dark bg-dark mb-5 py-1 py-md-2 py-lg-3 small">
    <div class="container">
      <button
        id="tools-api-title"
        class="navbar-toggler text-white font-weight-bold collapsed"
        type="button"
        data-toggle="collapse"
        data-target="#tools-nav-collapsed"
        aria-controls="tools-nav-collapsed"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="font-size: 1rem"
      >
        <i class="fas fa-caret-down mr-1"></i>
        <i class="fas fa-caret-up mr-1"></i>
        {{ heading }}
      </button>

      <div id="breadcrumb-search" class="navbar-brand d-inline-block d-lg-none" style="margin-right: 0px">
        <tool-search :featured_tools="featuredTools" :buttonActivation="true" />
      </div>

      <div class="collapse navbar-collapse mb-4 mb-lg-0" id="tools-nav-collapsed">
        <ul
          class="navbar-nav ml-0 mt-2 mt-lg-0 d-flex align-items-center flex-row flex-wrap justify-content-around mr-0 w-100 mr-0 mr-lg-3"
        >
          <!-- TOOLS & API -->
          <li class="nav-item nav-item-storefront my-2 my-lg-0">
            <a :href="toolsPath" class="text-decoration-none" @click="categoryClicked(toolsPath)">
              <div class="text-light d-flex flex-column align-items-center">
                <img :src="storefront.iconUrl" width="40" height="40" class="mb-2" />
                <span id="tools-api-title" class="storefront-heading">{{ storefront.heading }}</span>
                <div v-if="currentTab === 'featured'" class="featured tool-nav-arrow-up d-none d-lg-block"></div>
              </div>
            </a>
          </li>

          <!-- CATEGORIES -->
          <li
            v-for="category in categories"
            :key="category.slug"
            class="nav-item nav-item-tools-api my-2 my-lg-0"
            :data-category-slug="category.slug"
            :data-category-name="category.name"
          >
            <a :href="category.path" @click="categoryClicked(category.path)" class="text-decoration-none">
              <div class="text-light d-flex flex-column align-items-center">
                <img :src="category.iconUrl" width="40" height="40" class="mb-2" />
                <span>{{ category.name }}</span>
                <div v-if="currentTab === category.slug" class="tool-nav-arrow-up"></div>
              </div>
            </a>
          </li>

          <!-- API CLI -->
          <li class="nav-item nav-item-tools-api my-2 my-lg-0">
            <a :href="commandlineToolsPath" class="text-decoration-none" @click="categoryClicked(commandlineToolsPath)">
              <div class="text-light d-flex flex-column align-items-center">
                <img :src="cli.iconUrl" width="40" height="40" class="mb-2" />
                <span>{{ cli.heading }}</span>
                <div v-if="currentTab === 'api-commandline'" class="featured tool-nav-arrow-up"></div>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <div id="breadcrumb-search" class="navbar-brand d-none d-lg-inline-block breadcrumb-search-desktop">
        <tool-search :featured_tools="featuredTools" :buttonActivation="true" />
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { rbgToolPageNavigationClickedV100 } from "kaleido-event-tracker";
import ToolSearch from "./tool_search.vue";

interface Category {
  slug: string;
  name: string;
  iconUrl: string;
  path: string;
}

interface StorefrontData {
  heading: string;
  iconUrl: string;
}

interface CliData {
  heading: string;
  iconUrl: string;
}

interface ToolsNavigationProps {
  heading: string;
  categories: Category[];
  storefront: StorefrontData;
  cli: CliData;
  currentTab: string;
  featuredTools: any[];
  toolsPath: string;
  commandlineToolsPath: string;
}

const props = defineProps<ToolsNavigationProps>();

const categoryClicked = (categoryPath: string) => {
  rbgToolPageNavigationClickedV100({
    url_path: categoryPath,
  });
};
</script>

<style scoped>
.tool-nav-arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  margin-top: 4px;
}

.featured.tool-nav-arrow-up {
  border-bottom-color: #007bff;
}

.storefront-heading {
  font-weight: bold;
}

.nav-item a:hover .text-light {
  color: #ffffff !important;
}
</style>
